import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { FilterPipelineFilter } from 'record-it-components/hooks/useFilterPipeline/useFilterPipeline';
import { UserGroup } from '../../classes/entities/UserGroup/userGroupTypes';
import { UserGroupSelect } from '../../components/input/UserGroupSelect/UserGroupSelect';

/**
 * A filter for filtering entities by the ownerUserGroupId.
 * When a value gets select the filter will navigate to a new url
 *
 * This filter needs to be recreated each time the userGroupId of the url changes, since it has no internal state, because the state is in the url
 */
export function createUserGroupIdUrlFilter({
  userGroups,
  createUrl,
  currentUserGroupId
}: CreateUserGroupIdUrlFilterOptions): FilterPipelineFilter<
  { ownerUserGroupId: string },
  string
> {
  return {
    defaultValue: currentUserGroupId,
    filter: (item, value) => {
      return item.ownerUserGroupId === value;
    },
    Component: ({ value }) => {
      const navigate = useNavigate();

      const handleValueChanged = useEventCallback((id: string | null) => {
        if (id) navigate(createUrl(id));
      });

      return (
        <UserGroupSelect
          userGroupId={value}
          availableUserGroups={userGroups}
          onUserGroupChanged={handleValueChanged}
          data-testid="userGroupIdUrlFilter.Select"
        />
      );
    }
  };
}

export type UserGroupIdUrlFilter = FilterPipelineFilter<
  { ownerUserGroupId: string },
  string
>;

export type CreateUserGroupIdUrlFilterOptions = {
  userGroups: Array<UserGroup>;
  currentUserGroupId: string;
  createUrl: (userGroupId: string) => string;
};
